import { FC } from "react";

export type ApButtonStyle = "Blue" | "White";
export type ApButtonBorderRadiusStyle = "Normal" | "Rounded" | "None";
export type ApButtonHorizontalPaddingStyle = "Normal" | "Large" | "ExtraLarge" | "None";
export type ApButtonStylingOption = {
  btnBaseStyle: ApButtonStyle;
  borderRadiusStyle: ApButtonBorderRadiusStyle;
  horizontalPaddingStyle: ApButtonHorizontalPaddingStyle;
  className?: string;
};

interface ApButtonProps {
  innerText: string,
  btnStyleOption: ApButtonStylingOption,
  clickHandler?: () => void
}

const ApButton: FC<ApButtonProps> = ({ innerText, btnStyleOption, clickHandler }) => {
  const getBtnStyle = (btnStyle: ApButtonStyle) => {
    switch (btnStyle) {
      default:
      case "Blue": return "btn-style-1";
      case "White": return "btn-style-2";
    }
  };

  const getRadiusStyle = (borderRadiusStyle: ApButtonBorderRadiusStyle) => {
    switch (borderRadiusStyle) {
      default:
      case "Normal": return "4px";
      case "Rounded": return "30px";
      case "None": return "0px";
    }
  };

  const getHorizontalPaddingOption = (horizontalPaddingStyle: ApButtonHorizontalPaddingStyle) => {
    switch (horizontalPaddingStyle) {
      default:
      case "Normal": return "8px";
      case "Large": return "30px";
      case "ExtraLarge": return "60px";
      case "None": return "0px";
    }
  };

  const inlineStyle = {
    borderRadius: getRadiusStyle(btnStyleOption.borderRadiusStyle),
    paddingLeft: getHorizontalPaddingOption(btnStyleOption.horizontalPaddingStyle),
    paddingRight: getHorizontalPaddingOption(btnStyleOption.horizontalPaddingStyle)
  };

  return (
    <input type="button" style={inlineStyle} className={`${getBtnStyle(btnStyleOption.btnBaseStyle)} ${btnStyleOption.className}`} value={innerText} onClick={clickHandler}></input>
  );
}
export default ApButton;